import React, { useState, useEffect } from "react";
import { Typography, Input, message, Tabs, Dropdown, Menu, Button, Icon } from "antd";
import { platformApi } from "../../../api";
import { useBranch } from "../../../ContextAPI/branch";
import CustomerTable from "./CustomerTable";

const { Title } = Typography;
const { Search } = Input;
const { TabPane } = Tabs;

const ServiceFeedbackCall = () => {
  const { selectBranch } = useBranch();
  const [spinning, setSpinning] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState({ searchString: null });
  const [count, setCount] = useState(0);
  const [tab, setTab] = useState("PENDING");
  const [activeKey, setActivekey] = useState("1");

  useEffect(() => {
    if (selectBranch) {
      getServiceInvoices();
    }
  }, [page, limit, search, tab, selectBranch]);

  const getServiceInvoices = () => {
    setSpinning(true);
    
    // Construct payload based on tab
    const payload = {
      page: page,
      size: limit,
      jobStatus: ["PAID"],
      branch: Array.isArray(selectBranch) ? selectBranch.map(b => b.id) : [],
      searchString: search.searchString,
    };

    if (tab === "COMPLETED") {
      payload.status = "FEEDBACK_COMPLETED";
    }
     else if(tab === "PENDING") {
      payload.status = "!FEEDBACK_COMPLETED";
    }

    platformApi
      .post("/api/jobInvoice/get", payload)
      .then((res) => {
        setSpinning(false);
        if (res.data.code === 200) {
          const { saleSpareInvoice, count } = res.data.response.data;
          setDataSource(saleSpareInvoice);
          setCount(count);
        } else {
          message.error("Failed to fetch service invoices");
        }
      })
      .catch((error) => {
        setSpinning(false);
        message.error("Error fetching service invoices");
      });
  };

  const handleTabChange = (key) => {
    setActivekey(key);
    setPage(1);
    if (key === "1") {
      setTab("PENDING");
    } else {
      setTab("COMPLETED");
    }
  };

  const getMenu = () => {
    const menus = [10, 20, 50, 100];
    return (
      <Menu>
        {menus.map((m) => (
          <Menu.Item key={m} onClick={() => { setLimit(m); setPage(1); }}>
            {m}
          </Menu.Item>
        ))}
      </Menu>
    );
  };

  const menu = getMenu();

  return (
    <div>
      <div className="accessories-head" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <Title level={4} style={{ margin: 0 }}>
          Service Feedback Call [{count}]
          <span style={{ marginLeft: 16 }}>
            <Dropdown overlay={menu} trigger={["click"]}>
              <Button size="small">
                {limit} <Icon type="down" />
              </Button>
            </Dropdown>
          </span>
        </Title>
        <Search
          style={{ width: "30%" }}
          placeholder="Search Phone / Chassis"
          onSearch={(val) => {
            setSearch({ searchString: val });
            setPage(1);
          }}
          onChange={(e) => {
            if (!e.target.value) {
              setSearch({ searchString: null });
              setPage(1);
            }
          }}
        />
      </div>

      <Tabs activeKey={activeKey} onChange={handleTabChange}>
        <TabPane tab="Pending" key="1">
          <CustomerTable
            spinner={spinning}
            dataSource={dataSource}
            status={tab}
            pagination={{
              onChange: (p) => setPage(p),
              pageSize: limit,
              total: count,
              current: page,
              showQuickJumper: true,
            }}
          />
        </TabPane>
        <TabPane tab="Completed" key="2">
          <CustomerTable
            spinner={spinning}
            dataSource={dataSource}
            status={tab}
            pagination={{
              onChange: (p) => setPage(p),
              pageSize: limit,
              total: count,
              current: page,
              showQuickJumper: true,
            }}
          />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default ServiceFeedbackCall;
